import React from "react";
import StaticContainer from "components/Static/Container";

const DocsContainer = (props) => {
  const { children, navConfig, posts, ...customMeta } = props;

  const meta = {
    title: "PriceBlocs Docs",
    description: "Documentation on how to interact with the PriceBlocs API.",
    image: "https://priceblocs.com/meta/og-image-features-apiLinks.jpg",
    type: "website",
    ...customMeta
  };

  const containerProps = {
    index: {
      label: "Docs",
      path: "/"
    },
    show: {
      label: "Show docs menu"
    },
    children,
    navConfig,
    meta
  };

  return <StaticContainer key="docs-container" {...containerProps} />;
};

export default DocsContainer;
